import React from 'react'

import { Badge } from '@toasttab/buffet-pui-badge'

export const VerifiedStatus = ({ isVerified }: { isVerified: boolean }) => {
  const verifiedStatus = isVerified ? 'verified' : 'unVerified'

  return (
    <Badge
      className={'mx-2 -mt-1'}
      variant={'statusSm'}
      color={verifiedStatus === 'verified' ? 'success' : 'error'}
    >
      {isVerified ? 'VERIFIED' : 'UNVERIFIED'}
    </Badge>
  )
}
